import { gql } from '@reverbdotcom/commons/src/gql';

export const SELLING_FEE_LIMIT_QUERY = gql(`
  query CoreSellingFeeLimit($input: SellingFeeLimitInput!) {
    sellingFeeLimit(input: $input) {
      _id
      currency
      maxAmount {
        amountCents
      }
      minAmount {
        amountCents
      }
    }
  }
`);
